import { $$, prefersReducedMotion, supportsIntersectionObserver } from '../../lib/dom';
import { trackObserver } from '../router/page-lifecycle';

const STAGGER_STEP_MS = 70;

/** Fades `.rv` / `.rv-fade` elements in as they scroll into view; staggers children of `[data-stagger]`. */
export function initReveal(root: HTMLElement): void {
  $$('[data-stagger]', root).forEach((group) => {
    $$(':scope > .rv', group).forEach((el, i) => {
      el.style.setProperty('--d', `${i * STAGGER_STEP_MS}ms`);
    });
  });
  const elements = $$('.rv, .rv-fade', root);
  if (prefersReducedMotion() || !supportsIntersectionObserver()) {
    elements.forEach((el) => {
      el.classList.add('in');
    });
    return;
  }
  const observer = trackObserver(
    new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('in');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 },
    ),
  );
  elements.forEach((el) => {
    observer.observe(el);
  });
}

/** Pauses CSS animations of decorative elements while they are off-screen. */
export function initOffscreenPause(root: HTMLElement): void {
  if (!supportsIntersectionObserver()) return;
  const observer = trackObserver(
    new IntersectionObserver((entries) => {
      entries.forEach((entry) => entry.target.classList.toggle('paused', !entry.isIntersecting));
    }),
  );
  $$('.mesh, .arch, .sroute, .esc, .exec', root).forEach((el) => {
    observer.observe(el);
  });
}
